import { Navigate } from 'react-router-dom';

/** Раздел «Продажи» перенесён на главную страницу кабинета. */
export default function SellerSalesPage() {
  return <Navigate to="/" replace />;
}
